import {h, Fragment} from "preact"
import { useActions, useAppState } from '@nosto/preact'
import { defaultConfig, sortOptions } from '../config'

export default ({ sortByActive, toggleSortBy }) => {
    const { query } = useAppState();
    const { updateSearch } = useActions();

    const activeSort =
        sortOptions.find((option) =>
            option.value.sort.every((v1) =>
                query.products?.sort?.find(
                    (v2) => v1.field === v2.field && v1.order === v2.order
                )
            )
        )?.id ?? defaultConfig.sort.id
    
    const handleSortChange = (e) => {
        if(window.innerWidth <= 1000) {
            toggleSortBy();
        }
        updateSearch({
            products: {
                sort: sortOptions.find(
                    (v) => v.id === e?.target?.value
                )?.value?.sort,
            },
        })
    };

    return (
        <>
            <div class={`ns-sortby ${sortByActive ? 'active' : ''}`}>
                <div class="ns-sortby-header mobile">
                    <span class="popover__title heading h6">Sort By</span>
                    <button type="button" class="popover__close-button tap-area tap-area--large" onClick={toggleSortBy}>
                        <svg focusable="false" width="14" height="14" class="icon icon--close" viewBox="0 0 14 14"><path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="1.2" fill="none"></path></svg>
                    </button>
                </div>
                <div class="ns-sortby-content">
                    {sortOptions.map((option) => (
                        <label class='popover__choice-item'>
                            <input checked={(activeSort === option.id)} type="radio" class='visually-hidden' name="sort-by" value={option.id} onChange={handleSortChange} />
                            <span class="popover__choice-label">{option.value.name}</span>
                        </label>
                    ))}
                </div>
            </div>
            <div class="ns-sortby-backdrop" onClick={toggleSortBy}></div>
        </>
    )
}
